<template>
    <register-layout v-on:submit="submit">
        <div class="tw-grid tw-grid-cols-1 tw-gap-6 tw-p-6">
            <div class="tw-text-xl tw-font-bold">{{$text.select_your_interests}}</div>

            <div class="tw-flex tw-flex-wrap tw-p-2">
                <div
                    tabindex="0" v-for="interest in states.interests" v-on:click="toggleInterest(interest)"
                    class="tw-cursor-pointer tw-rounded tw-px-3 tw-py-1 tw-m-1"
                    :class="interestIsActive(interest) ? 'tw-bg-blue-600 tw-text-white' : 'tw-bg-gray-50 hover:tw-bg-blue-50'"
                >{{interest.title}}
                </div>
            </div>

        </div>
    </register-layout>
</template>
<script>
    import store from './register-store'
    import RegisterLayout from './register-layout'

    export default {
        components: {RegisterLayout},
        data: v => ({
            states: store.states,
            errors: {},
        }),
        created() {
            this.store = store
        },
        methods: {
            submit() {
                store.states.loading = true
                axios.post('/validate-register', store.composeForm())
                    .then(() => {
                        this.errors = {}
                    })
                    .catch(err => {
                        err.response.status === 422 && (this.errors = err.response.data.errors)
                    })
                    .finally(() => {
                        store.states.loading = false
                        store.states.current_step++
                    })
            },
            interestIsActive(interest) {
                return store.states.form.interests.includes(interest.id)
            },
            toggleInterest(interest) {
                if (this.interestIsActive(interest)) {
                    store.states.form.interests = store.states.form.interests.filter(item => item !== interest.id)
                } else {
                    store.states.form.interests = [...store.states.form.interests, interest.id]
                }
            }
        },
    }
</script>
